import styled from 'styled-components'

interface CircleStepProps {
  currentStep: number
  maxStep: number
}

const CircleStep = ({ currentStep, maxStep }: CircleStepProps) => {
  return (
    <Wrapper>
      <CircleBg>
        <circle className="st0" cx="30" cy="30" r="28" />
      </CircleBg>

      <CircleLineStroke percent={currentStep/maxStep}>
        <circle className="st0" cx="30" cy="30" r="28" />
      </CircleLineStroke>

      <StepNumber>
        {currentStep} of {maxStep}
      </StepNumber>
    </Wrapper>
  )
}

export default CircleStep

const Wrapper = styled.div`
  position: relative;
  height: 60px;
`

const CircleBg = styled.svg`
  width: 60px;
  height: 60px;

  .st0 {
    fill:none;
    stroke:#FFFFFF;
    stroke-width:4;
  }
`

const CircleLineStroke = styled.svg<{ percent: number }>`
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-180deg);

  .st0 {
    fill: none;
    stroke: var(--global--color-background-secondary);
    stroke-width: 4;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-dasharray: 1000;
    transition: .3s;
    stroke-dashoffset: ${({ percent }) => 1000 - 175 * percent}; // Value Between 1000 - 825 = 175
  }
`

const StepNumber = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: white;
`